import React, { useEffect, useState } from "react";
//import scss
import "../certified-payroll/earningCodes.scss";
import Grid from "../../../../../../components/grid";
import RadiosRenderer from "../../../../../../components/grid/RadiosRenderer";

const EarningCodes = props => {
    const [earningCodes, setEarningCodes] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);

    useEffect(() => {
        setEarningCodes(props.mappedEarningCodes || []);
        setColumnDefs([
            {
                headerName: "Earning Code",
                field: "earningCode",
                width: 225,

            },
            {
                headerName: "Earning Type",
                field: "earningType",
                resizable: true,
                width: 450,
                cellRenderer: RadiosRenderer,
                cellRendererParams: {
                    onChange: props.onTypeChange,
                    radioValues: [
                        { val: "straight", label: "Straight" },
                        { val: "overtime", label: "Overtime" },
                        { val: "benefit", label: "Benefit" },
                        { val: "excluded", label: "Excluded" },
                    ],
                    nameProp: "systemId"
                },
            }
        ]);
    }, [props.mappedEarningCodes?.length]);

    return (
        <>
            <div className="full-box mt-0">
                <div className="clients_grid">
                    <Grid
                        columnDefs={columnDefs}
                        rowData={earningCodes}
                        height='600px'
                    >
                    </Grid>
                </div>
            </div>
        </>
    );
};



export default EarningCodes;